import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Adenoid Surgery & Removal in Delhi, India | Treatment, Cost, Doctor, Clinic </title>
            <meta name="description" content="Get safe and effective adenoid surgery & removal in Delhi, India. Learn about adenoid treatment, procedure, recovery, and affordable surgery cost. Book Now." />
            <meta name="keywords" content="Adenoid Surgery Cost, Adenoid Removal Surgery, Adenoid Surgery, Adenoids Treatment" />
            <link rel="canonical" href="https://entdelhi.com/adenoid-surgery/" />
            <meta property="og:title" content="Adenoid Surgery & Removal in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get safe and effective adenoid surgery & removal in Delhi, India. Learn about adenoid treatment, procedure, recovery, and affordable surgery cost. Book Now." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
